<dtm-ui-loader-container [isShown]="isProcessing$ | ngrxPush" class="content">
    <ng-container *ngrxLet="weatherConditions$ | ngrxPush as conditions">
        <h2>{{ "dtmMapCesium.detailedPressure.pressureLabel" | transloco : { zone: zone$ | ngrxPush } }}</h2>
        <div class="mean-pressure-value">
            <ng-container *ngIf="meanPressure$ | ngrxPush as meanPressure$; else noDataTemplate">
                {{
                    "dtmMapCesium.detailedPressure.pressureValueLabel"
                        | transloco : { value: meanPressure$ | ngrxPush | localizeNumber : { maximumFractionDigits: 2 } }
                }}
            </ng-container>
        </div>
        <ng-container *ngIf="hasStationsData$ | ngrxPush">
            <h3>{{ "dtmMapCesium.detailedPressure.sourceStationsLabel" | transloco }}</h3>
            <div class="pressure-container" *ngFor="let item of conditions | keyvalue">
                <div class="pressure-item">
                    <span class="label">{{ item.key }}</span>
                    <span class="date">
                        {{ item.value.weatherConditions.lastMeasurementTime | localizeDate : { timeStyle: "medium" } }}
                    </span>
                    <span class="value">
                        {{
                            "dtmMapCesium.detailedPressure.pressureValueLabel"
                                | transloco
                                    : {
                                          value:
                                              item.value.weatherConditions.pressure.meanPressureAtStationLevelHpa
                                              | localizeNumber : { maximumFractionDigits: 2 }
                                      }
                        }}
                    </span>
                </div>
            </div>
        </ng-container>
    </ng-container>
</dtm-ui-loader-container>
<ng-template #noDataTemplate> - - </ng-template>
